import React, { useState, useEffect } from "react";
// import React from "react";
import BackButton from "../../components/BackButton";
import NavSpacer from "../../components/NavSpacer";
import Breadcrumbs from "../../components/Breadcrumbs";
import SlideShow from "../../components/SlideShow";
import returnYear from "../../utils/GetYear";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import peopleScapesNewCollection from "./../../data/Paintings/PeoplescapesNew_Data";

function PeoplescapesNew() {
  const [thisYear, setThisYear] = useState("2023");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setThisYear(returnYear());
  }, []);

  return (
    <div>
      <Helmet>
        <title>Peoplescapes 2024 - {`${thisYear}`} — Paintings by Tyrone Layne</title>
        <link rel='canonical' href='https://tyronelayne.com/paintings/peoplescapes-new' />
        {/* <meta
          property='og:image'
          content={peopleScapesNewCollection[0].image}
        /> */}
      </Helmet>
      <NavSpacer />
      <Breadcrumbs />
      <SlideShow
        slides={peopleScapesNewCollection}
        slideShowName='peoplescapesNew'
        startingIndex={1}
        scrollOffset={-40}
      />
      <div style={{ textAlign: "center", margin: "4rem 0 2rem 0" }}>
        <Link
          to="/painting-shop"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "inline-block",
            padding: "14px 32px",
            backgroundColor: isHovered ? "#000" : "transparent",
            color: isHovered ? "#fff" : "#000",
            border: "1px solid #000",
            borderRadius: "0",
            fontSize: "0.85rem",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            textDecoration: "none",
            transition: "background-color 0.2s ease, color 0.2s ease",
            fontFamily: "inherit",
          }}
        >
          Shop available Peoplescapes
        </Link>
      </div>
      <BackButton />
    </div>
  );
}

export default PeoplescapesNew;
